import React from "react";
import { connect } from "react-redux";

import { Link } from "react-router-dom";

import { formatPrice, formatTitleInUrl, CarTransmission, renderNumberGreaterThan100, stypes } from "../common/common";

import { IcStarRating, IcTotalTrip, IcAddrCar, IcInstant, IcHeartActive } from "../common/svg";

import car_photo from "../../static/images/upload/car_1.png";
import avatar_default from "../../static/images/avatar_default.png";

const CarItemMyFavs = (props) => {
	const { car, mode, removeFromFavorites, appInit } = props;
	const priceMode = appInit?.data?.priceMode;
	const hiddenFeeMode = priceMode === 2;


	return (
		<div className="item-car row">
			<div className="item-box">
				<Link
					to={{
						pathname: `/car/${mode === stypes.SD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`,
					}}>
					<div className="img-car">
						<div className="fix-img">
							<img loading="lazy" src={car.photos ? car.photos[0].thumbUrl : car_photo} />
						</div>
						<div className="wrap-svg fav-item">
							<IcHeartActive />
						</div>
						{mode === stypes.SD ? (
							<span className="label-pos">
								{car.instant > 0 && (
									<span className="rent">
										Đặt xe nhanh <IcInstant />
									</span>
								)}
							</span>
						) : (
							<span className="label-pos">
								{car.wdShort && car.wdShort.instant === 1 && (
									<span className="rent">
										Đặt xe nhanh <IcInstant />
									</span>
								)}
							</span>
						)}

						{mode === stypes.SD
							? car.totalDiscountPercent > 0 && <span className="discount">Giảm {car.totalDiscountPercent}%</span>
							: car.wdShort &&
							  car.wdShort.totalDiscountPercent > 0 && (
									<span className="discount">Giảm {car.wdShort.totalDiscountPercent}%</span>
							  )}
					</div>
				</Link>
				<div className="desc-car">
					<div className="desc-tag">
						<span className={`tag-item ${car.optionsTransmission === 1 ? "transmission" : "delivery"}`}>
							{CarTransmission[car.optionsTransmission]}
						</span>

						{mode === stypes.SD ? (
							<>
								{car.deliveryEnable === 1 && car.deliveryPrice > 0 && (
									<span className="tag-item non-mortgage">Giao xe tận nơi</span>
								)}
								{car.deliveryEnable === 1 && car.deliveryPrice === 0 && (
									<span className="tag-item non-mortgage">Miễn phí giao xe</span>
								)}
							</>
						) : null}
					</div>
					<div className="desc-name">
						<p>{car.name}</p>
					</div>
					<div className="desc-info">
						{car.totalTrips > 0 ? (
							<>
								<div className="wrap-svg">
									<IcStarRating />
								</div>
								<span className="info">{car.rating.avg.toFixed(1)}</span>
								<span className="dot">•</span>
								<div className="wrap-svg">
									<IcTotalTrip />
								</div>
								<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
							</>
						) : (
							<>
								<span className="info">Chưa có chuyến</span>
							</>
						)}
					</div>

					<div className="desc-address-price">
						<div className="address">
							<div className="wrap-svg">
								<IcAddrCar />
							</div>
							<p>{car.locationAddrS}</p>
						</div>
					</div>
					<div className="line"> </div>
					<div className="desc-price">
						{mode === stypes.SD ? (
							hiddenFeeMode ? (
								<div className="price">
									{car.priceOriginWithFee !== car.priceWithFee && (
										<span className="price-origin">{formatPrice(car.priceOriginWithFee)}</span>
									)}
									<span className="price-special">
										{formatPrice(car.priceWithFee)}
										<span className="day">/&nbsp;ngày</span>
									</span>
								</div>
							) : (
								<div className="price">
									{car.priceOrigin !== car.price && (
										<span className="price-origin">{formatPrice(car.priceOrigin)}</span>
									)}
									<span className="price-special">
										{formatPrice(car.price)}
										<span className="day">/&nbsp;ngày</span>
									</span>
								</div>
							)
						) : hiddenFeeMode ? (
							<div className="price">
								{car.wdShort && car.wdShort.priceOriginWithFee !== car.wdShort.priceWithFee && (
									<span className="price-origin">{formatPrice(car.wdShort.priceOriginWithFee)}</span>
								)}
								{car.wdShort && (
									<span className="price-special">
										{formatPrice(car.wdShort.priceWithFee)}
										<span className="day">/&nbsp;chuyến</span>
									</span>
								)}
							</div>
						) : (
							<div className="price">
								{car.wdShort && car.wdShort.priceOrigin !== car.wdShort.price && (
									<span className="price-origin">{formatPrice(car.wdShort.priceOrigin)}</span>
								)}
								{car.wdShort && (
									<span className="price-special">
										{formatPrice(car.wdShort.price)}
										<span className="day">/&nbsp;chuyến</span>
									</span>
								)}
							</div>
						)}
						<Link
							to={{
								pathname: `/car/${mode === stypes.SD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`,
							}}
							className="btn btn-primary btn--s">
							Chọn xe
						</Link>
					</div>
				</div>
				<div className="profile">
					<div className={`avatar avatar--s ${car.ownerHostFiveStar > 0 ? "has-five-star" : ""}`}>
						<img loading="lazy" src={car.ownerAvatar && car.ownerAvatar !== "" ? car.ownerAvatar : avatar_default} />
					</div>
					{mode === stypes.SD ? (
						hiddenFeeMode ? (
							<div className="price">
								{car.priceOriginWithFee !== car.priceWithFee && (
									<span className="price-origin">{formatPrice(car.priceOriginWithFee)}</span>
								)}
								<span className="price-special">
									{formatPrice(car.priceWithFee)}
									<span className="day">/&nbsp;ngày</span>
								</span>
							</div>
						) : (
							<div className="price">
								{car.priceOrigin !== car.price && <span className="price-origin">{formatPrice(car.priceOrigin)}</span>}
								<span className="price-special">
									{formatPrice(car.price)}
									<span className="day">/&nbsp;ngày</span>
								</span>
							</div>
						)
					) : hiddenFeeMode ? (
						<div className="price">
							{car.wdShort && car.wdShort.priceOriginWithFee !== car.wdShort.priceWithFee && (
								<span className="price-origin">{formatPrice(car.wdShort.priceOriginWithFee)}</span>
							)}
							{car.wdShort && (
								<span className="price-special">
									{formatPrice(car.wdShort.priceWithFee)}
									<span className="day">/&nbsp;chuyến</span>
								</span>
							)}
						</div>
					) : (
						<div className="price">
							{car.wdShort && car.wdShort.priceOrigin !== car.wdShort.price && (
								<span className="price-origin">{formatPrice(car.wdShort.priceOrigin)}</span>
							)}
							{car.wdShort && (
								<span className="price-special">
									{formatPrice(car.wdShort.price)}
									<span className="day">/&nbsp;chuyến</span>
								</span>
							)}
						</div>
					)}
					<a
						className="btn btn--s btn-primary"
						onClick={(e) => {
							removeFromFavorites(car.id, mode);
							e.preventDefault();
						}}>
						Bỏ thích
					</a>
					<Link
						to={{
							pathname: `/car/${mode === stypes.SD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`,
						}}
						className="btn btn-link btn--s">
						{" "}
						Xem chi tiết
					</Link>
				</div>
			</div>
		</div>
	);
};

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(CarItemMyFavs);
